if (!HTMLFormElement.prototype.requestSubmit) {
	HTMLFormElement.prototype.requestSubmit = function (submitter) {
		if (submitter) {
			submitter.click();
			return;
		}

		const tempSubmitButton = document.createElement("button");
		tempSubmitButton.type = "submit";
		tempSubmitButton.style.display = "none";
		this.appendChild(tempSubmitButton);
		tempSubmitButton.click();
		this.removeChild(tempSubmitButton);
	};
}

jQuery(document).foundation();
